module.exports = __webpack_public_path__ + "img/heart-handshake.57703f45.svg";